import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FETCH_FTTB_SPECIAL_TARIFF_ERROR, FETCH_FTTB_SPECIAL_TARIFF_START, FETCH_FTTB_SPECIAL_TARIFF_SUCCESS, SET_FTTB_SPECIAL_TARIFF_SHOW_IF_EXIST, SET_FTTB_SPECIAL_TARIFF_TYPE } from "../actions/actionTypes";
import { mapToPromoTariff } from "../../utils/legacy/mapToPromoTariff";
var reducers = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FETCH_FTTB_SPECIAL_TARIFF_START, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSpecialTariffData: _objectSpread(_objectSpread({}, state.fttbSpecialTariffData), {}, {
      state: 'loading',
      showSpecTariffIfExist: payload.showSpecTariffIfExist
    })
  });
}), FETCH_FTTB_SPECIAL_TARIFF_SUCCESS, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSpecialTariffData: _objectSpread(_objectSpread({}, state.fttbSpecialTariffData), {}, {
      state: 'loaded',
      tariff: payload.tariff ? mapToPromoTariff(payload.tariff) : null,
      tariffFullModel: payload.tariff ? payload.tariff : null,
      availabilitySpecialTariff: payload.tariff ? 'available' : 'notAvailable',
      houseId: payload.houseId
    })
  });
}), FETCH_FTTB_SPECIAL_TARIFF_ERROR, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSpecialTariffData: {
      state: 'error'
    }
  });
}), SET_FTTB_SPECIAL_TARIFF_TYPE, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSpecialTariffData: _objectSpread(_objectSpread({}, state.fttbSpecialTariffData), {}, {
      fetchTariffType: payload.type && payload.type.toLowerCase()
    })
  });
}), SET_FTTB_SPECIAL_TARIFF_SHOW_IF_EXIST, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSpecialTariffData: _objectSpread(_objectSpread({}, state.fttbSpecialTariffData), {}, {
      showSpecTariffIfExist: payload.show
    })
  });
});
export var fttbSpecialTariffData = function fttbSpecialTariffData(state, action) {
  var reducer = reducers[action.type];
  return typeof reducer === 'function' ? reducer(state, action.payload) : state;
};